import { CargoFiltro, ValoresFiltrosHistoriaLaboral } from 'components/Experiencia';
import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";

import "./Experiencia.scss"

type PropsFiltroExperiencia = {
    filtro: ValoresFiltrosHistoriaLaboral,
    filtrosUsando: StateFiltrosUsadosExperiencia,
    onClickFiltrar: (filtros: StateFiltrosUsadosExperiencia) => void
}




export type StateFiltroExperiencia = {
    desde: number | undefined,
    hasta: number | undefined,
    cargo: string | undefined,
    relacion: string | undefined,
    funcion: string | undefined,

}

export type StateFiltrosUsadosExperiencia = {
    desde: string | undefined
    hasta: string | undefined
    cargo: string | undefined
    relacion: string | undefined
    funcion: string | undefined

}

export default function FiltrosExperiencia(props: PropsFiltroExperiencia) {

    const initialState: StateFiltroExperiencia = {
        cargo: undefined,
        desde: undefined,
        hasta: undefined,
        relacion: undefined,
        funcion: undefined
    }

    const initialStateFiltrosUsados: StateFiltrosUsadosExperiencia = {
        cargo: undefined,
        desde: undefined,
        hasta: undefined,
        relacion: undefined,
        funcion: undefined

    }


    const [stateFiltrosUsados, setstateFiltrosUsados] = useState<StateFiltrosUsadosExperiencia>(initialStateFiltrosUsados)

    const [stateFiltro, setstateFiltro] = useState<StateFiltroExperiencia>(initialState)
    const [errorAnios, seterrorAnios] = useState<string>("")


    useEffect(() => {
        setstateFiltrosUsados(props.filtrosUsando)
    }, [props.filtrosUsando])



    const onChangeAnio = useCallback(
        (e, tipo: string) => {
            const valorSeleccionado = e.target.value;
            if (tipo === "desde") {
                setstateFiltrosUsados({ ...stateFiltrosUsados, desde: valorSeleccionado })
                setstateFiltro({ ...stateFiltro, desde: +valorSeleccionado })
            }
            else if (tipo === "hasta") {
                setstateFiltrosUsados({ ...stateFiltrosUsados, hasta: valorSeleccionado })
                setstateFiltro({ ...stateFiltro, hasta: +valorSeleccionado })
            }
        },
        [stateFiltrosUsados, stateFiltro]
    )

    const onClickFiltar = useCallback(
        () => {
            props.onClickFiltrar(stateFiltrosUsados);
        },
        [stateFiltrosUsados, props]
    )

    const onChangeCargo = useCallback(
        (e) => {
            const valorSeleccionado = e.target.value;
            setstateFiltrosUsados({ ...stateFiltrosUsados, cargo: valorSeleccionado })
            setstateFiltro({ ...stateFiltro, cargo: valorSeleccionado })
        }, [stateFiltrosUsados, stateFiltro],
    )

    const onChangeTipoRelacion = useCallback(
        (e) => {
            const valorSeleccionado = e.target.value;
            setstateFiltrosUsados({ ...stateFiltrosUsados, relacion: valorSeleccionado })
            setstateFiltro({ ...stateFiltro, relacion: valorSeleccionado })
        }, [stateFiltrosUsados, stateFiltro],
    )

    const onChangeTipoFuncion = useCallback(
        (e) => {
            const valorSeleccionado = e.target.value;
            setstateFiltrosUsados({ ...stateFiltrosUsados, funcion: valorSeleccionado })
            setstateFiltro({ ...stateFiltro, funcion: valorSeleccionado })
        }, [stateFiltrosUsados, stateFiltro],
    )


    const onClickReiniciar = useCallback(
        () => {
            setstateFiltro(initialState)
            const reiniciarFiltro: StateFiltrosUsadosExperiencia = { cargo: "todos", desde: "0", hasta: "0", relacion: "todos", funcion: "todos" }
            setstateFiltrosUsados(reiniciarFiltro)
            props.onClickFiltrar(reiniciarFiltro);

        },
        [stateFiltrosUsados, stateFiltro],
    )


    const FiltroCargos = useMemo(() => {

        const {funcion} = stateFiltrosUsados

        
        var cargosFiltrados = [...props.filtro.cargo];

        if(funcion === "todos" ||  funcion === undefined || funcion === ""){
            ;
        }
        else {
            cargosFiltrados = cargosFiltrados.filter(c => c.tipoFuncion === funcion)
        }

        if(props.filtro.anios.length === 0){
            return undefined
        }

        return (
            <Col md={2} >
                <FormGroup className="btnExperienciaFiltro">
                    <Label for="cargo">Cargo</Label>

                    <Input name="cargo" type="select" onChange={(e) => onChangeCargo(e)} defaultValue={""} value={stateFiltrosUsados.cargo} >
                        <option disabled value="" > </option>
                        <option value="todos">Todos</option>
                        {
                            cargosFiltrados.map((val, ind) => {
                                return (
                                    <option
                                        key={"optiondesdefiltroexp " + ind}
                                        value={val.cargo.toString()}
                                    >
                                        {val.cargo}
                                    </option>
                                )
                            })
                        }
                    </Input>
                </FormGroup>
            </Col>
        )
    }

        , [stateFiltro, stateFiltrosUsados,props])

    useEffect(() => {
        const { desde, hasta } = stateFiltrosUsados

        if (desde && hasta) {
            const desdeParse = +desde
            const hastaParse = +hasta
            if (desdeParse > 0 && hastaParse > 0 && desdeParse > hastaParse) {
                seterrorAnios("Debe elegir un rango válido, el año 'desde' debe ser menor al 'hasta'")
            }
            else {
                seterrorAnios("")
            }

        }
    }, [stateFiltro.desde, stateFiltro.hasta, stateFiltrosUsados.desde, stateFiltrosUsados.hasta])


    const { anios, cargo, tipoFuncion, tipoRelacion } = props.filtro
    return (

        <React.Fragment>
            <Form >
                <Row>
                    <Col md={2}>
                        <FormGroup className="">
                            <Label for="desde">Año desde</Label>
                            <Input name="desde" type="select" onChange={(e) => onChangeAnio(e, "desde")} defaultValue={""} value={stateFiltrosUsados.desde}>
                                <option disabled value="" ></option>
                                <option value="0">Todos</option>
                                {
                                    anios.map((val, ind) => {
                                        return (
                                            <option
                                                key={"optiondesdefiltroexp " + ind}
                                                value={val.toString()}
                                            >
                                                {val}
                                            </option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="hasta"> Año hasta </Label>

                            <Input name="hasta" type="select" onChange={(e) => onChangeAnio(e, "hasta")} defaultValue={""} value={stateFiltrosUsados.hasta}>
                                <option disabled value="" >  </option>
                                {
                                    anios.map((val, ind) => {
                                        return (
                                            <option
                                                key={"optiondesdefiltroexp " + ind}
                                                value={val.toString()}
                                            >
                                                {val}
                                            </option>
                                        )
                                    })
                                }
                            </Input>

                        </FormGroup>
                    </Col>
                    <Col md={2} >
                        <FormGroup className="btnExperienciaFiltro">
                            <Label for="relacion">Tipo Función</Label>

                            <Input name="relacion" type="select" onChange={(e) => onChangeTipoFuncion(e)} defaultValue={""} value={stateFiltrosUsados.funcion} >
                                <option disabled value="" > </option>
                                <option value="todos">Todos</option>
                                {
                                    tipoFuncion.map((val, ind) => {
                                        return (
                                            <option
                                                key={"optiondesdefiltroexp " + ind}
                                                value={val.toString()}
                                            >
                                                {val}
                                            </option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    {/* <Col md={2} >
                        <FormGroup className="btnExperienciaFiltro">
                            <Label for="relacion">Tipo Relacion</Label>

                            <Input name="relacion" type="select" onChange={(e) => onChangeTipoRelacion(e)} defaultValue={""} value={stateFiltrosUsados.relacion} >
                                <option disabled value="" > </option>
                                <option value="todos">Todos</option>
                                {
                                    tipoRelacion.map((val, ind) => {
                                        return (
                                            <option
                                                key={"optiondesdefiltroexp " + ind}
                                                value={val.toString()}
                                            >
                                                {val}
                                            </option>
                                        )
                                    })
                                }
                            </Input>
                        </FormGroup>
                    </Col> */}

                    {FiltroCargos}                


                    <Col md={6} xl={2} className="columnHideFiltro">
                        <div className="containerBotonExperienciaFiltro pt-3">
                            {
                                errorAnios === "" &&
                                (
                                    <Button type="button" className="btn secondary" onClick={() => onClickFiltar()}>
                                        Filtrar
                                    </Button>
                                )
                            }

                            <Button className="secondary" type="button" onClick={() => onClickReiniciar()}>
                                Reiniciar
                            </Button>
                        </div>
                    </Col>
                    <Col md={2} xl={1} className={""}>
                        <div className="containerBotonExperienciaFiltro">

                        </div>

                    </Col>

                </Row>
                <Row>
                    <Col>
                        <small className="small-error">{errorAnios}</small>
                    </Col>
                </Row>
                <Row>

                </Row>
                <Row className="justify-content-center rowHideFiltro">
                    <Col sm={12} md={6} xl={2} className="text-center">
                        <div className="containerBotonExperienciaFiltro pt-3">
                            {
                                errorAnios === "" &&
                                (
                                    <Button type="button" className="btn secondary" onClick={() => onClickFiltar()}>
                                        Filtrar
                                    </Button>
                                )
                            }

                            <Button className="secondary" type="button" onClick={() => onClickReiniciar()}>
                                Reiniciar
                            </Button>
                        </div>
                    </Col>
                </Row>


            </Form>

        </React.Fragment>


    )
}
